import script from "./MFA.vue?vue&type=script&setup=true&lang=js"
export * from "./MFA.vue?vue&type=script&setup=true&lang=js"

import "./MFA.vue?vue&type=style&index=0&id=7cee4cd2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cee4cd2"]])

export default __exports__